var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3338_34672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1094 12.4883C24.1094 15.6709 22.8451 18.7231 20.5947 20.9736C18.3442 23.224 15.292 24.4883 12.1094 24.4883C8.92678 24.4883 5.87453 23.224 3.62409 20.9736C1.37366 18.7231 0.109375 15.6709 0.109375 12.4883C0.109375 9.30568 1.37366 6.25344 3.62409 4.003C5.87453 1.75256 8.92678 0.488281 12.1094 0.488281C15.292 0.488281 18.3442 1.75256 20.5947 4.003C22.8451 6.25344 24.1094 9.30568 24.1094 12.4883ZM18.1544 7.94328C18.0472 7.83651 17.9197 7.75244 17.7793 7.6961C17.6389 7.63977 17.4886 7.61232 17.3374 7.6154C17.1861 7.61848 17.0371 7.65203 16.8991 7.71403C16.7611 7.77604 16.6371 7.86523 16.5344 7.97628L11.3249 14.6138L8.18538 11.4728C7.97211 11.2741 7.69004 11.1659 7.39859 11.171C7.10714 11.1762 6.82906 11.2942 6.62294 11.5003C6.41682 11.7065 6.29876 11.9845 6.29361 12.276C6.28847 12.5674 6.39665 12.8495 6.59538 13.0628L10.5644 17.0333C10.6713 17.14 10.7986 17.2241 10.9388 17.2806C11.0789 17.337 11.2289 17.3647 11.38 17.3619C11.531 17.3591 11.68 17.3259 11.8179 17.2643C11.9559 17.2027 12.08 17.1139 12.1829 17.0033L18.1709 9.51828C18.375 9.30603 18.4878 9.02219 18.485 8.72772C18.4822 8.43324 18.364 8.15161 18.1559 7.94328H18.1544Z",
    fill: "#027A48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3338_34672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.109375 0.488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFill);
export default __webpack_public_path__ + "static/media/check-circle-fill.171b48e5ac6c023bf7945d56dbeaeb46.svg";
export { ForwardRef as ReactComponent };